// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-45c6734e] .treeNode .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content .custom-tree-node.mb {\n  background-color: #007efd!important;\n  color: #fff;\n  padding: 3px;\n  border-radius: 3px;\n}\n", ""]);
// Exports
module.exports = exports;
